/***
 *
 * Please Do not use this Component.
 */
import styles from "./BadgeList.module.css";
import { BadgeElement } from "../BadgeElement";
import { useIntl } from "react-intl";
import { SKILL_LEVEL } from "../../../utils/constants";
import { useState } from "react";

const BadgeList = (props: any) => {
  const { badges, handleDownloadPdfClick, handleDownloadImgClick, redirectUrl, handleRedirectToCourse, handleDownloadAllCheckedPdf, handleDownloadAllCheckedImg } = props;
  const { formatMessage } = useIntl();
  const [downloadNum, setDownloadNum] = useState(0);

  const [checkedBadges, setCheckedBadges] = useState<any[]>([]);

  const handleBadgeSelect = (badge: any, isChecked: boolean) => {
    setCheckedBadges((prev) =>
      isChecked ? [...prev, badge] : prev.filter((b) => b.id !== badge.id)
    );
  };

  const handleDownloadAllPdf = () => {
    handleDownloadAllCheckedPdf(checkedBadges);
  };

  const handleDownloadAllImg = () => {
    handleDownloadAllCheckedImg(checkedBadges);
  };

  return (
    <>
      <div className={styles.courseText}>Course:</div>
      <div className={styles.rightaligned}>
        <div className={styles.downloadicons}>
          {!downloadNum
            ? formatMessage({ id: "alm.text.downloadAll" })
            : formatMessage({ id: "alm.text.download" })}
          :
          <div className={styles.downloadoptions}>
            <div className={styles.downloadlink}>
              <a
                analytics-training-name=""
                analytics-training-id=""
                analytics-download-type="all"
                analytics-file-type="pdf"
                onClick={handleDownloadAllPdf}
                className={`${styles.pdf} btn-certificate-download`}
                tabIndex={0}
                aria-label={
                  downloadNum
                    ? formatMessage(
                      { id: "alm.badge.downloadNumPdf" },
                      { downloadNum }
                    )
                    : formatMessage({ id: "alm.badge.downloadAllPdf" })
                }
              >
                {downloadNum
                  ? formatMessage(
                    { id: "alm.text.pdfNum" },
                    { num: downloadNum }
                  )
                  : formatMessage({ id: "alm.text.pdf" })}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.badgelist}>

        <ul className={styles.list}>

          {badges.map((el: any) =>
              el.model?.type !== SKILL_LEVEL ? (
                <BadgeElement
                  key={el.id}
                  id={el.id}
                  loDetails={el.model.id}
                  badge={el.badge}
                  dateAchieved={el.dateAchieved}
                  badgeAquiredForType={
                    el.model.loType
                      ? formatMessage({ id: `alm.text.${el.model.loType}` })
                      : formatMessage({ id: 'alm.text.skill' })
                  }
                  badgeTypeName={
                    el.model.type === SKILL_LEVEL
                      ? el.model.skill.name
                      : el.model.localizedMetadata[0].name
                  }
                  redirectUrl={redirectUrl}
                  num={downloadNum}
                  setNum={setDownloadNum}
                  handleDownloadPdfClick={handleDownloadPdfClick}
                  handleDownloadImgClick={handleDownloadImgClick}
                  handleRedirectToCourse={handleRedirectToCourse}
                  onBadgeSelect={handleBadgeSelect}
                />
              ) : null
            )}

          <div className={styles.new}></div>
        </ul>

      </div>
    </>
  );
};

export default BadgeList;
